
export const LOCAL_STORAGE_KEYS = {
    REMEMBER_LAST_EMAIL: "remember-last-email",
    REMEMBER_LAST_NAME: "remember-last-name",
    REMEMBER_LAST_PHONE: "remember-last-phone",
    PASSKEY_USED_LOCALLY: "passkey-used-locally",
    PASSKEY_AUTO_ADD_PROMPTED_AT: "passkey-auto-add-prompted-at",
};
